import endsWith from 'lodash/endsWith';
import { UserProps } from '@/context/auth';
import { Option } from '@/context/profile-builder';
import { JobTitleDataValue } from '@/context/job-title';
import { JobOpportunityType } from '@/components/job-opportunity-panel';

export const HOT_LEVEL = { id: 'hot', name: '热门', aliaName: '全网' };
export const EXIST_LOCATIONS = 'exist_locations';
export const SALARY_RANK = 'salary_rank';
export const OPEN_JOB_RANK = 'open_job_rank';

export type SalaryRankType = {
  avg: number;
  job_title_id: string;
  job_title_name: string;
  job_title_detail: Pick<
    JobTitleDataValue,
    'salary_details' | 'job_open_details' | 'current_count_group_by_experience'
  >;
};

export type OpenJobRankType = {
  current_count: number;
  job_title_id: string;
  job_title_name: string;
  open_job_by_month: { name: string; value: number }[];
};

export type JobTitleRankType = {
  exist_locations: { children: Option[] }[] & Option[];
  [SALARY_RANK]: SalaryRankType[];
  [OPEN_JOB_RANK]: OpenJobRankType[];
  job_title_name: string;
  city_name: string;
  hot_job_opportunities?: JobOpportunityType[];
};

export interface JobRankProps extends UserProps {
  levelOneData: Option[];
  rankData: JobTitleRankType;
  filterId: string;
  l1Data: Option | undefined;
  recommendL1Data: Option[];
  pageData: SalaryRankType[] | OpenJobRankType[];
  canonical: string;
  city: string;
}

export const renameL1Name = (id: string, name: string) => {
  return id === HOT_LEVEL.id ? '' : endsWith(name, '类') ? name : name + '类';
};

export const getL1Data = (
  filterId: string | undefined,
  levelOneData: Option[],
) => {
  if (filterId) {
    const data = levelOneData.find((item) => item.id === filterId);
    if (data) {
      const { id, name } = data;
      const rename = renameL1Name(id, name);
      return {
        id,
        name: rename,
      };
    }
  }
};
